import React from "react";
import FaqComponents from "../../components/common/faq";
import { Col, Container, Row } from "react-bootstrap";

const faqs = [
  {
    question: "How long does it take to develop an eCommerce app?",
    answer: ` <p>An e-commerce app can be built in as few as 100 hours, or in as many as 400 hours.</p>
            <p>The specific timeframe primarily relies on the complexity of your application. In general, if you need highly custom designs, niche features, or non-standard release platforms, the development process is likely to take a longer duration.</p>`,
  },
  {
    question: "What is the development process of an eCommerce app?",
    answer: `<p>Here is the development process of an e-commerce app:</p>  
        <ul>
        <li>Research </li>
        <li>Setting a Goal</li>
        <li>Choosing the Right Platform</li>
        <li>Define Feature Set</li>
        <li>Creating UI and UX Design</li>
        <li>Building an MVP</li>
        <li>Gather Feedback</li>
        <li>Iterate</li>
    </ul>`,
  },
  {
    question:
      "Why should you consider “Tekrevol” as your partner for developing eCommerce mobile apps?",
    answer: `<p>You should consider TekRevol as your partner for developing e-commerce mobile apps as it our forte.</p>
    <p>When creating e-commerce applications, we focus on custom areas, ensuring they align with the requirements of both the business and the end-user.</p>`,
  },
  {
    question:
      "Why is it important For Business Owners To Create An Ecommerce Applications?",
    answer: `<p>It is important for business owners to create an e-commerce application because of the following reasons</p>
    <ul>
    <li>Brand Recognition</li>
    <li>Customer Loyalty</li>
    <li>Increased efficiency and higher revenues</li>
    <li>Access to customer data</li>
    <li>Speed and Analytics</li>
    </ul>
    `,
  },
  {
    question: "How much does it cost to build an eCommerce app?",
    answer: `<p>The average cost to build an e-commerce app ranges from $25,000 and $30,000.</p>
    <p>Incorporating AI and personalized features into the app could lead to an increase in the development cost, reaching approximately $35,000.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Ecommerce App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
